<template>
  <div>
    <v-data-table
      :headers="headers"
      :loading="loading"
      :search="search"
      :items="mysqlUsers">
      <template v-slot:item.databases="{ item }">
        <databases-cell
          :databases="item.databases"
          :user="item.user"
          @action-completed="actionCompleted($event)"
        />
      </template>
      <template v-slot:item.actions="{ item }">
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on, attrs }">
            <gg-btn v-on="on" v-bind="attrs">
              Manage <v-icon right>mdi-chevron-down</v-icon>
            </gg-btn>
          </template>
          <v-list>
            <v-list-item @click="openPrivilegesModal(item)">
              <v-list-item-title>Assign to Database</v-list-item-title>
            </v-list-item>
            <v-list-item @click="openPasswordModal(item)">
              <v-list-item-title>Change Password</v-list-item-title>
            </v-list-item>
<!--            <v-list-item @click="openRenameModal(item)">-->
<!--              <v-list-item-title>Rename</v-list-item-title>-->
<!--            </v-list-item>-->
            <v-list-item @click="openDeleteModal(item)">
              <v-list-item-title>Delete</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>
    <delete-user-modal
      v-if="deleteModalOpened"
      :opened="deleteModalOpened"
      :user="selectedUser"
      @close="closeDeleteModal"
      @action-completed="actionCompleted($event)"
    />
    <rename-user-modal
      v-if="renameModalOpened"
      :opened="renameModalOpened"
      :user="selectedUser"
      @close="closeRenameModal"
      @action-completed="actionCompleted($event)"
    />
    <user-password-modal
      v-if="passwordModalOpened"
      :opened="passwordModalOpened"
      :user="selectedUser"
      @close="closePasswordModal"
      @action-completed="actionCompleted($event)"
    />
    <add-user-modal
      v-if="privilegesModalOpened"
      :user="selectedUser.user"
      mode="user"
      :opened="privilegesModalOpened"
      @close="closePrivilegesModal"
      @action-completed="actionCompleted($event)"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DeleteUserModal from './DeleteUserModal'
import RenameUserModal from './RenameUserModal'
import UserPasswordModal from './UserPasswordModal'
import DatabasesCell from './DatabasesCell'
import AddUserModal from '../Databases/AddUserModal'

export default {
  name: 'UsersTable',
  components: {
    DeleteUserModal,
    RenameUserModal,
    UserPasswordModal,
    DatabasesCell,
    AddUserModal
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'User',
          value: 'user'
        },
        {
          text: 'Databases',
          value: 'databases'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'center',
          sortable: false
        }
      ],
      selectedUser: null,
      deleteModalOpened: false,
      renameModalOpened: false,
      passwordModalOpened: false,
      privilegesModalOpened: false
    }
  },
  computed: {
    ...mapGetters({
      mysqlUsers: 'mysql/mysqlUsers'
    }),
  },
  methods: {
    actionCompleted (e) {
      switch (e) {
        case 'user-deleted':
          this.closeDeleteModal()
          break
        case 'user-renamed':
          this.closeRenameModal()
          break
        case 'user-password-changed':
          this.closePasswordModal()
          break
        default:
          break
      }
      this.$emit('table-action-completed', e)
    },
    openDeleteModal (user) {
      this.selectedUser = user
      this.deleteModalOpened = true
    },
    closeDeleteModal () {
      this.selectedUser = null
      this.deleteModalOpened = false
    },
    openRenameModal (user) {
      this.selectedUser = user
      this.renameModalOpened = true
    },
    closeRenameModal () {
      this.selectedUser = null
      this.renameModalOpened = false
    },
    openPasswordModal (user) {
      this.selectedUser = user
      this.passwordModalOpened = true
    },
    closePasswordModal () {
      this.selectedUser = null
      this.passwordModalOpened = false
    },
    openPrivilegesModal (user) {
      this.selectedUser = user
      this.privilegesModalOpened = true
    },
    closePrivilegesModal () {
      this.selectedUser = null
      this.privilegesModalOpened = false
    },
  },
}
</script>
